import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../../styles/Team.module.css';

const MonetizedPagesList = ({ pages, onPageClick, timeRange }) => {
  // Debug logging
  console.log('MonetizedPagesList received pages:', pages);
  console.log('MonetizedPagesList received timeRange:', timeRange);
  
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  const formatNumber = (value) => {
    return new Intl.NumberFormat('en-US').format(value);
  };

  const formatRPM = (rpm) => {
    return `$${rpm.toFixed(2)}`;
  };

  return (
    <div className={styles.monetizedPagesContainer}>
      <div className={styles.monetizedPagesHeader}>
        <h3>
          <FontAwesomeIcon icon="table" style={{ marginRight: '8px' }} />
          Monetized Pages
        </h3>
        <p>Pages with earnings &gt; $0.00 for {timeRange === 1 ? 'yesterday' : `last ${timeRange} days`}</p>
      </div>
      
      <div className={styles.monetizedPagesList}>
        <div className={styles.monetizedPagesListHeader}>
          <div className={styles.pageNameHeader}>Page Name</div>
          <div className={styles.earningsHeader}>Earnings</div>
          <div className={styles.rpmHeader}>Video RPM</div>
          <div className={styles.viewsHeader}>Video Views</div>
          <div className={styles.impressionsHeader}>Impressions</div>
          <div className={styles.ctrHeader}>CTR</div>
        </div>
        
        {pages.map((page, index) => {
          const ctr = page.total_impressions > 0 
            ? (page.total_video_views / page.total_impressions) * 100 
            : 0;
          
          return (
            <div 
              key={page.page_id} 
              className={styles.monetizedPageItem}
              onClick={() => onPageClick(page)}
            >
              <div className={styles.pageNameCell}>
                <div className={styles.pageAvatar}>
                  <FontAwesomeIcon icon="user" />
                </div>
                <div className={styles.pageInfo}>
                  <div className={styles.pageName}>{page.page_name}</div>
                  <div className={styles.pageId}>ID: {page.page_id}</div>
                </div>
              </div>
              
              <div className={styles.earningsCell}>
                <span className={styles.earningsAmount}>
                  {formatCurrency(page.total_approximate_earnings)}
                </span>
              </div>
              
              <div className={styles.rpmCell}>
                <span className={styles.rpmValue}>
                  {formatRPM(page.video_rpm)}
                </span>
              </div>
              
              <div className={styles.viewsCell}>
                <span className={styles.viewsCount}>
                  {formatNumber(page.total_video_views)}
                </span>
              </div>
              
              <div className={styles.impressionsCell}>
                <span className={styles.impressionsCount}>
                  {formatNumber(page.total_impressions)}
                </span>
              </div>
              
              <div className={styles.ctrCell}>
                <span className={styles.ctrValue}>
                  {ctr.toFixed(2)}%
                </span>
              </div>
            </div>
          );
        })}
      </div>
      
      {pages.length === 0 && (
        <div className={styles.emptyState}>
          <FontAwesomeIcon icon="search" />
          <p>No monetized pages found for this time period</p>
          <span>Try adjusting the time range or check back later</span>
        </div>
      )}
    </div>
  );
};

export default MonetizedPagesList; 